import Pawn from './Pawn';
import { PawnController } from './pawnController';

export default Pawn;
export { PawnController };